export default {
  id: "StudentSettings",
  code: "CN",
  text: {
    'Student': '学员',
    'Input Fields Setting': '学生报名信息设置',
    'Basic Info': '基本信息',
    'Name': '学员姓名',
    'Last Name': '学员姓',
    'First Name': '学员名',
    'Gender': '学员性别',
    'DOB': '学员生日',
    'Contact Number': '联系电话',
    'Tag':'标签',
    'Parent Name':'家长姓名',
    'Remark': '备注',
    'Save': '保存',
    'Contact': '联系人',
    'Contact Custom Fields': '联系人自定义字段'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClientSettings/locale.js